

export class NumberHelper {
    static valueOrDefault(value: number | undefined | null) {
        return value !== undefined && value !== null
            ? value
            : 0;
    }

    static stripZeros(obj: any): any {
        if (!obj) return obj;
        
        for (let p in obj) {
            if (obj[p] === 0) {
                delete obj[p];
            } else if (typeof obj[p] === 'object') {
                NumberHelper.stripZeros(obj[p]);
            }
        }

        return obj;
    }
}


export function parseIntSafe(input: any): number | undefined {
    try {
        if (input === null || input === undefined) return undefined;

        // If it's already a number and not NaN
        if (typeof input === "number") {
            return isNaN(input) ? undefined : input;
        }

        // Convert other types to string
        const str = String(input).trim();
        if (!str) return undefined;

        const num = parseInt(str);

        return isNaN(num) ? undefined : num;
    } catch {
        const float = parseFloatSafe(input);

        if (typeof float === 'number') {
            return Math.round(float);
        } else {
            return undefined;
        }
    }
}


export function parseFloatSafe(input: any): number | undefined {
    if (input === null || input === undefined) return undefined;

    // If it's already a number and not NaN
    if (typeof input === "number") {
        return isNaN(input) ? undefined : input;
    }

    // Convert other types to string
    const str = String(input).trim();
    if (!str) return undefined;

    const num = parseFloat(str);

    return isNaN(num) ? undefined : num;
}

/**
 * Round to `precision` decimal places, replacing `Sugar.Number.round`.
 *
 * Deliberately the naive scale-round-unscale, because that is exactly what
 * Sugar did and money totals are formatted through it. Rounding is half-up in
 * the JavaScript sense, so -2.5 rounds to -2, not -3. A negative `precision`
 * rounds to tens/hundreds: `roundToPrecision(1234.5678, -2)` is 1200.
 */
export function roundToPrecision(value: number, precision: number = 0): number {
    let multiplier = Math.pow(10, Math.abs(precision));
    if (precision < 0) {
        multiplier = 1 / multiplier;
    }
    return Math.round(value * multiplier) / multiplier;
}

/**
 * Group digits with thousands separators and a fixed number of decimals,
 * replacing `Sugar.Number.format` — e.g. `(1234567.891, 2)` is "1,234,567.89".
 *
 * The locale is pinned rather than left to the host so a plan's numbers read
 * the same for everyone looking at it.
 */
export function formatNumberWithSeparators(value: number, decimals: number = 0): string {
    return value.toLocaleString('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
}

export function toTwoDecimalPlaces(input: number | string | any) {
    if (input == null) return '';
    let num = parseFloatSafe(input);

    if (typeof num !== 'undefined') {
        if (isNaN(num)) return input;

        // Format to max 2 decimals, then remove trailing zeros
        return num.toFixed(2).replace(/\.?0+$/, '');

    } else {
        return '';
    }
};
